import React from "react";
import checked from "./../../../Images/checked.png";

const ChromeGelBenefits = () => {
  return (
    <div className="nailExtensionWhy">
      <h5> Benefits of Chrome Gel Polish in Bangalore at SCENT </h5>
      <p>
        Choosing chrome gel polish in Bangalore at SCENT comes with numerous
        benefits:
      </p>
      <ul>
        <li>
          <span>
            <img src={checked} alt="" />
            Long-Lasting Shine :{" "}
          </span>
          <p>
            The mirror-like finish of{" "}
            <a href="https://scentlifestyle.com/service">chrome gel polish </a>
            retains its shine for weeks, giving your nails a consistently
            polished look.
          </p>
        </li>
        <li>
          <span>
            <img src={checked} alt="" /> Durability:{" "}
          </span>
          <p>
            Chrome gel polish is resistant to chipping and peeling, making it a
            practical choice for those with busy lifestyles.
          </p>
        </li>
        <li>
          <span>
            <img src={checked} alt="" />
            Unique Designs:{" "}
          </span>
          <p>
            {" "}
            The versatility of chrome gel polish allows for a wide range of
            designs, from simple elegance to bold statements.
          </p>
        </li>
        <li>
          <span>
            <img src={checked} alt="" />
            Healthy Nails:
          </span>
          <p>
            {" "}
            The high-quality products used at{" "}
            <a href="https://scentlifestyle.com/service">SCENT</a> ensure that
            your nails remain healthy and strong, even after multiple
            applications.
          </p>
        </li>
      </ul>
    </div>
  );
};

export default ChromeGelBenefits;
